import { createContext, useContext } from "react";
import type { SheetDragHandleProps } from "./useSheetDragToClose";

/**
 * The drag zone's handlers of the sheet around this content, or `null` when it is not drag-to-close. Lets a step's
 * heading (`SheetStep`) be a drag zone too, as the grab handle is — the artifact drags from both — without the sheet
 * knowing what its content draws.
 */
export const SheetDragHandleContext = createContext<SheetDragHandleProps | null>(null);

export const useSheetDragHandle = (): SheetDragHandleProps | null => useContext(SheetDragHandleContext);
